import axios from 'axios';
import apiConfig from '../api.config';

export default function getEstablishmentTypes() {
  const {
    host,
    URIs: { getEstablishmentTypes },
  } = apiConfig;

  const uri = `${host}${getEstablishmentTypes}`;

  return axios
    .get(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
